import * as React from 'react'
import { observer, inject } from 'mobx-react'
import LocalizationStore from '../../../../Stores/LocalizationStore'
import { 
    TroubleEvent,
    getTroubleEventTypeText,
    getTroubleEventStatusClass,
    getTroubleEventStatusText,
    TroubleEventStatus } from '../../../../Model/TroubleEvent'
import DateTimeHelper from '../../../../Helpers/DateTimeHelper'
import { NavLink } from 'react-router-dom'
import HttpActionsService from '../../../../Services/HttpActionsService'
import { getTroubleEventAvailaibleStatuses } from '../../../../Helpers/StatusHelper'
import DebtInfoView from '../DebtInfoView'

export interface ITroubleEventDetailViewProps {
    item: TroubleEvent
    localizationStore?: LocalizationStore
    httpActionsService?: HttpActionsService
}

@inject('localizationStore')
@inject('httpActionsService')
@observer
export default class TroubleEventDetailView extends React.Component<ITroubleEventDetailViewProps> {
    changeStatus(e: any, id: string, status: TroubleEventStatus) {
        e.preventDefault()
        const { httpActionsService } = this.props
        httpActionsService!.changeTroubleEventStatus(id, status)
    }

    render() {
        const { localizationStore, item } = this.props
        let statuses = getTroubleEventAvailaibleStatuses(item.type, item.status)
        return (
            <form className="rjsf">
                <div className="form-group field field-object">
                    <div className="row">
                        <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 troubleEventDetais">
                            <fieldset>
                                {/* <legend className="legend">{localizationStore.t('TroubleEvent')}</legend> */}
                                <div className="troubleEventInfo row">
                                    <div
                                        className="troubleEventImplement 
                                    col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12"
                                    >
                                        <div className="eventDates">
                                            <div className="form-group field field-string">
                                                <label>
                                                    {localizationStore!.t('createDate')}
                                                </label>: &nbsp;
                                            <span>
                                                    {DateTimeHelper.formatDateForList(item.createDate)} /
                                            </span>
                                            </div>
                                            <div className="form-group field field-string">
                                                <label>{localizationStore!.t('endDate')}</label>: &nbsp;
                                            <span>
                                                    {DateTimeHelper.formatDateForList(item.endDate)} /
                                            </span>
                                            </div>
                                            <div className="form-group field field-string">
                                                <label>{localizationStore!.t('assignDate')}</label>: &nbsp;
                                            <span>
                                                    {DateTimeHelper.formatDateForList(item.assignDate)}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="form-group field field-string">
                                            <label>{localizationStore!.t('inProgressByUserIds')}</label>: &nbsp;
                                        <NavLink to={'/user/' + item.assignedUserId}>
                                                {item.assignedUserId}
                                            </NavLink>
                                        </div>
                                        <DebtInfoView credit={item.credit}/>
                                    </div>
                                    <div
                                        className="troubleEventStatusType 
                                    col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
                                    >
                                        <div className="form-group field field-string">
                                            <label>{localizationStore!.t('troubleEventType')}</label>: &nbsp;
                                        <span>{getTroubleEventTypeText(item.type)}</span>
                                        </div>
                                        <div className="form-group field field-string">
                                            <label>{localizationStore!.t('troubleEventStatus')}</label>: &nbsp;
                        <span className={'change-status ' + getTroubleEventStatusClass(item.status)}>
                                                {getTroubleEventStatusText(item.status)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <div className="trobleEventStatuses col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                            {statuses.map((x, i) =>
                                <button
                                    key={'status-code-' + x}
                                    className={'change-status ' + getTroubleEventStatusClass(x)}
                                    onClick={(e) => this.changeStatus(e, item.id, x)}
                                >
                                    {getTroubleEventStatusText(x)}
                                </button>)
                            }
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/TroubleEvent/TroubleEventDetailView/index.tsx